/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Label_Tax_CodeInputs */

const vi_receipt_label_tax_code = /** @type {(inputs: Receipt_Label_Tax_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã số thuế`)
};

/**

* @param {Receipt_Label_Tax_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_label_tax_code = /** @type {((inputs?: Receipt_Label_Tax_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Label_Tax_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_label_tax_code(inputs)
});